/* eslint-disable react/prop-types */
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import { useNavigate } from "react-router-dom";
import SoftBadge from "../../components/SoftBadge";
import fixTableCellWidth from "../../utils/fixTableCellWidth";
import { useState } from 'react';
import { deleteBadge } from 'services/badge.routes';
import Loading from 'components/Loading';
import { toast } from 'react-toastify';


function Row(props) {
    const { row, navigate, handleDeleteBadge } = props;

    return (
        <React.Fragment>
            <TableRow
                sx={{ '& > *': { borderBottom: 'unset' }, backgroundColor: row.id % 2 === 1 ? "" : "rgba(204,204,204,0.1)" }}>
                <TableCell className="tablecell" align="left" title={row.name}
                    style={fixTableCellWidth("160px")}>{row.name}</TableCell>
                <TableCell className="tablecell" align="left" title={row?.category?.name}
                    style={fixTableCellWidth("140px")}>{row?.category?.name}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("120px")}><img src={row.icon} style={{ width: 60 }} /></TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("150px")}><section style={{ display: "flex", cursor: 'pointer' }}>
                        <SoftBadge variant="contained"
                            onClick={() => navigate(`/new-badge?method=update`, { state: row })}
                            badgeContent="آپدیت"
                            color="secondary" size="xs" />
                        <SoftBadge variant="contained"
                            badgeContent="حذف" onClick={() => handleDeleteBadge(row.id)}
                            color="error" size="xs" />
                    </section></TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function BadgeTable({ data }) {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);

    const handleDeleteBadge = (badgeId) => {
        let answer = window.confirm("آیا از حذف اطمینان دارید؟");
        if (answer) {
            setLoading(true);
            deleteBadge(badgeId, (isOk, data) => {
                if (!isOk) {
                    setLoading(false);
                    return toast.error(data.message)
                } else {
                    setLoading(false);
                    toast.success("نشان حذف شد!");
                }
            })
        }
    }
    return (
        <>
            <Loading loading={loading} />
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <SoftBadge onClick={() => navigate("/new-badge")} variant="contained"
                            badgeContent="نشان جدید" color="success" size="xs"
                            container
                            style={{ cursor: 'pointer' }} />
                        <SoftBadge onClick={() => navigate("/badge-category")} variant="contained"
                            badgeContent="دسته بندی نشان" size="xs"
                            container
                            style={{ cursor: 'pointer', marginRight: 10 }} />
                        <TableRow>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>نام</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>دسته بندی</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("130px")}>آیکون</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>عملیات</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody style={{ display: 'block' }}>
                        {data.map((row) => (
                            <Row key={row.id} row={row} navigate={navigate} handleDeleteBadge={handleDeleteBadge} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}
